export const localStorageConstants = {
  SIDEBAR_STATE_KEY: "sidebar_expanded",
};
